<template>

    <div id="">
        <ul class="newListTab fl">
            <li v-for="(item, idx) in listTabData" :key="idx" :class="{'active':isActive === idx}"
                @click="tabClick(idx, item.id)">{{item.title}}</li>
        </ul>

    </div>
</template>

<script>



export default {
    name: '',
    components: {

    },

    props: {
        listTabData: {
            type: Array,
            default: []
        },

    },

    data () {
        return {
            isActive: 0,
        }
    },

    computed: {

    },
    created () {

    },

    mounted () {

    }
    ,
    methods: {
        tabClick (idx, catid) {
            this.isActive = idx;
            console.log('tab切换id=====', catid)

            let navCategoryPageParams = {
                catid: catid,
                limit: 7
            }

            this.$store.dispatch('navCategoryPage', navCategoryPageParams)
                .then((res) => {
                    if (res.code == 200) {
                        res.catid = catid
                        this.$emit('clickTabList', res)
                    }
                }).catch(error => {
                    console.log('catch====', error)
                })
        },
    }
}
</script>

<style scoped>
.newListTab {
    overflow: hidden;
}
.newListTab li {
    float: left;
    border-bottom: 2px solid #4280ff;
    padding: 0 20px;
    font-size: 16px;
    cursor: pointer;
    color: #4280ff;
    /* font-weight: bold; */
}

.newListTab li.active {
    background: #4280ff;
    color: #fff;
    /* font-weight:bold; */
}
.newListTab li a:hover {
    display: block;
    color: red;
}
.newListTab li.active:nth-child(1) {
    border-top-right-radius: 18px;
}

.newListTab li.active:nth-child(2) {
    border-top-left-radius: 18px;
}

.bottomContRight .newLists {
    margin-top: 23px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/newsListTab.vue